import { createFileRoute } from "@tanstack/react-router";
import { Wrench, Clock, Mail } from "lucide-react";

export const Route = createFileRoute("/maintenance")({
  component: MaintenancePage,
  head: () => ({
    meta: [
      { title: "We'll be right back — Spayzo" },
      {
        name: "description",
        content:
          "Spayzo is undergoing scheduled maintenance. We'll be back online shortly.",
      },
    ],
  }),
});

function MaintenancePage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-background">
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_hsl(var(--primary)/0.12),_transparent_60%)]" />
      <div className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-6 py-16 text-center">
        <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-2xl bg-primary/10 text-primary ring-1 ring-primary/20">
          <Wrench className="h-9 w-9" />
        </div>
        <h1 className="text-balance text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
          We're tuning things up
        </h1>
        <p className="mt-4 max-w-md text-pretty text-base text-muted-foreground">
          Spayzo is currently undergoing scheduled maintenance to bring you a
          better experience. We'll be back online shortly — thanks for your
          patience.
        </p>

        <div className="mt-8 grid w-full max-w-md gap-3 sm:grid-cols-2">
          <div className="flex items-center gap-3 rounded-lg border bg-card p-4 text-start">
            <Clock className="h-5 w-5 shrink-0 text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">Estimated</p>
              <p className="text-xs text-muted-foreground">~30 minutes</p>
            </div>
          </div>
          <a
            href="mailto:support@spayzo.app"
            className="flex items-center gap-3 rounded-lg border bg-card p-4 text-start transition-colors hover:bg-accent"
          >
            <Mail className="h-5 w-5 shrink-0 text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">Support</p>
              <p className="text-xs text-muted-foreground">support@spayzo.app</p>
            </div>
          </a>
        </div>

      </div>
    </div>
  );
}
